<img [default]='"assets/images/ID37_Grafik_Gauss_en.svg"'
     [src]='"assets/images/ID37_Grafik_Gauss_"+locale.toLowerCase()+".svg"'
     alt="id37 motives gaussian distribution">

<ul class="id37-text2 text-light">
  <li *ngFor="let bulletPoint of graphicGaussText.bulletPointTexts" [innerHTML]="bulletPoint"></li>
</ul>
